<template>
	<div class="showModal custom-modal">
		<div v-if="instruments[symbol]">
			<div class="buySell-popup text-center openBuySell openPendingOrder" v-if="tempOrderId.length == 0">
				<span class="closePOP" @click="$parent.orderMod = {}"><feather size="13px" type="x"></feather></span>
				<div class="mainContent buy">
					<div class="titleHead border-bottom pb-3">
						<p class="f-16 text-left pl-2">{{$t('modify_order')}}</p>
					</div>
					<ul class="openOrder-list mb-3">	
						<li>{{$t('order')}} <span>{{order.OrderID}}</span></li>
						<li>{{$t('trades')}} <span :class="sideClass[order.Side]">{{sideValue[order.Side] || '-'}}</span></li>
						<li>{{$t('type')}} <span>{{orderType[order.Type] || '-'}}</span></li>
					</ul>
					<form class="marKet form-data" v-if="parseInt(order.Side) == 1 && order.Type == 'ES'">
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('price')}}:  {{order.Price}}</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('price')}}<sup class="red">*</sup></label>
			                            <input type="number" :step="getStep(price)" :min="instruments[symbol].A" :placeholder="instruments[symbol].other.closepx" v-model="price" name="Price" v-validate="{'required':true, greaterThen : instruments[symbol].A}" ref="priceInput" @keyup="keyUp($event,'price')"/>
			                            <span class="addHighLow">
										    <a href="javascript:void(0)" @click.stop="changeTick('priceInput',1,'price')"><feather type="plus"></feather> </a>
										    <a href="javascript:void(0)" @click.stop="changeTick('priceInput',0,'price')"><feather type="minus"></feather> </a>
										</span>
									</div>
									<span class="text-danger-error" v-if="submitted && errors.has('Price')">
				                        <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required')}}</span>
				                        <span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_greater_then')}} {{ instruments[symbol].A}}</span>
				                        <span class="text-danger" v-else>{{ errors.first('Price') }}</span>
				                    </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('volume')}}:  {{order.Quantity?(order.Quantity / contractSize):'0'}} {{$t('lot')}}</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('quantity')}}<sup class="red">*</sup></label>
		                                <input type="number" step="0.01" :min="getMinQuantity()" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true, 'max_value': 100, 'min_value': getMinQuantity()}" autocomplete="off" ref="quantityInput" />
		                                <span class="addHighLow">
                                            <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                            <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
									<span class="text-danger-error" v-if="submitted && errors.has('quantity')">
		                                <span class="text-danger" v-if="errors.first('quantity').includes('decimal points')">{{$t('quantity_required')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
		                            </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('stop_loss')}}
	                                <input type="checkbox" v-model="edit_stop"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('rate')}}<sup class="red" v-if="edit_stop">*</sup></label>
		                                <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, lessThen : price, greaterThen : 0}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_stop">
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
	                                <span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
		                                <span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_less_greater_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
		                            </span>
								</div>
								
							</div>
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('trailing_stop_loss')}}:
	                                <input type="checkbox" v-model="edit_trail"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Trailing Stop Loss: -</p> -->
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
		                                <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_trail">
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
		                                <span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greate_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-4 text-left">
								<label class="customCheckbox green">
	                                {{$t('Take Profit')}}:
	                                <input type="checkbox" v-model="edit_limit"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Take Profit: -</p> -->
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>Price<sup class="red" v-if="edit_limit">*</sup></label>
		                                <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, greaterThen : price}" v-if="edit_limit" :ref="'Take ProfitInput'" @keyup="keyUp($event,'limit')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_limit">
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',1,'limit')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',0,'limit')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
		                                <span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_greater_price_level')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('limit') }}</span>
		                            </span>
								</div>
							</div>
						</div>
					</form>
					<form class="marKet form-data" v-else-if="parseInt(order.Side) == 1 && order.Type == 'EL'">
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('price')}}:  {{order.Price}}</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('price_level')}}<sup class="red">*</sup></label>
			                            <input type="number" :step="getStep(price)" min="0" :placeholder="instruments[symbol].other.closepx" v-model="price" name="Price" v-validate="{'required':true, 'lessThen' : instruments[symbol].A, greaterThen:0}" :ref="'Price levelInput'"/>
			                            <span class="addHighLow" v-if="edit_limit">
	                                        <a href="#" @click.prevent="changeTick('Price levelInput',1,'price')"><feather type="plus"></feather> </a>
	                                        <a href="#" @click.prevent="changeTick('Price levelInput',0,'price')"><feather type="minus"></feather> </a>
	                                    </span>
									</div>
									<span class="text-danger-error" v-if="submitted && errors.has('Price')">
				                        <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required')}}</span>
				                        <span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_must_be_less_than')}} {{ instruments[symbol].A}} {{$t('and_greater_than_zero')}} 0</span>
				                        <span class="text-danger" v-else>{{ errors.first('Price') }}</span>
				                    </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('volume')}}:  {{order.Quantity?(order.Quantity / 100000):'0'}} lot</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('quantity')}}<sup class="red">*</sup></label>
		                                <input type="number" step="0.01" :min="getMinQuantity()" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':100,'min_value':getMinQuantity()}" autocomplete="off" ref="quantityInput"/>
		                                <span class="addHighLow">
                                                <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                                <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                            </span>
		                            </div>
									<span class="text-danger-error" v-if="submitted && errors.has('quantity')">
		                                <span class="text-danger" v-if="errors.first('quantity').includes('decimal points')">{{$t('quantity_required')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
		                            </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('stop_loss')}}
	                                <input type="checkbox" v-model="edit_stop"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('rate')}}<sup class="red" v-if="edit_stop">*</sup></label>
		                                <input type="number" :step="getStep(stop)" :min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, 'lessThen' : price, 'greaterThen' : 0}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_stop">
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
		                                <span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_less_greater_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('trailing_stop_loss')}}:
	                                <input type="checkbox" v-model="edit_trail"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Trailing Stop Loss: -</p> -->
								<div class="form-fields mx-0">
									<div class="d-flex align-items-center lightBC">
										<label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
		                                <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_trail">
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
		                                <span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greate_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-4 text-left">
								<label class="customCheckbox green">
	                                {{$t('Take Profit')}}:
	                                <input type="checkbox" v-model="edit_limit"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Take Profit: -</p> -->
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
		                                <input type="number" :step="getStep(limit)" min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, greaterThen : price}" v-if="edit_limit" :ref="'Take ProfitInput'" @keyup="keyUp($event,'limit')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_limit">
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',1,'limit')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',0,'limit')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
		                                <span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_greater_price_level')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('limit') }}</span>
		                            </span>
								</div>
							</div>
						</div>
					</form>
					<form class="marKet form-data" v-else-if="parseInt(order.Side) == 0 && order.Type == 'ES'">
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('price')}}:  {{order.Price}}</p>
								<div class="form-fields d-flex align-items-center mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('trigger_price')}}<sup class="red">*</sup></label>
			                            <input type="number" :step="getStep(price)" :min="0" :placeholder="instruments[symbol].other.closepx" v-model="price" name="Price" v-validate="{'required':true, 'lessThen' : instruments[symbol].B, greaterThen:0}" ref="triggerPriceInput"/>
			                            <span class="addHighLow">
                                            <a href="#" @click.prevent="changeTick('triggerPriceInput',1,'price')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('triggerPriceInput',0,'price')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error" v-if="submitted && errors.has('Price')">
				                        <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required')}}</span>
				                        <span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_must_be_less_than')}} {{ instruments[symbol].B}} {{$t('greater_then_zero')}} 0</span>
				                        <span class="text-danger" v-else>{{ errors.first('Price') }}</span>
				                    </span>
									</div>
								</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('volume')}}:  {{order.Quantity?(order.Quantity / 100000):'0'}} {{$t('lot')}}</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('quantity')}}<sup class="red">*</sup></label>
		                                <input type="number" step="0.01" :min="getMinQuantity()" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':100,'min_value':getMinQuantity()}" autocomplete="off" ref="quantityInput"/>
		                                <span class="addHighLow">
                                            <a href="#" @click.prevent="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error" v-if="submitted && errors.has('quantity')">
		                                <span class="text-danger" v-if="errors.first('quantity').includes('decimal points')">{{$t('quantity_required')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
		                            </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('stop_loss')}}
	                                <input type="checkbox" v-model="edit_stop"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('rate')}}<sup class="red" v-if="edit_stop">*</sup></label>
		                                <input type="number" :step="getStep(stop)" min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, greaterThen : price}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_stop">
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
		                                <span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_trigger_price')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('trailing_stop_loss')}}:
	                                <input type="checkbox" v-model="edit_trail"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Trailing Stop Loss: -</p> -->
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
	                                    <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
	                                    <input type="number" min="1" placeholder="100" name="Trail" v-model="trail" disabled v-else/>
	                                    <span class="addHighLow" v-if="edit_trail">
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
		                                <span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greate_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-4 text-left">
								<label class="customCheckbox green">
	                                {{$t('Take Profit')}}:
	                                <input type="checkbox" v-model="edit_limit"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Take Profit: -</p> -->
								<div class="form-fields d-flex align-items-center mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
		                                <input type="number" :step="getStep(limit)" :min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, lessThen : price, greaterThen:0}" v-if="edit_limit" :ref="'Take ProfitInput'" @keyup="keyUp($event,'limit')" />
		                                <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_limit">
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',1,'limit')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',0,'limit')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
		                                <span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_greater_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('limit') }}</span>
		                            </span>
								</div>
							</div>
						</div>
					</form>
					<form class="marKet form-data" v-else-if="parseInt(order.Side) == 0 && order.Type == 'EL'">
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('price')}}:  {{order.Price}}</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('market_range')}}<sup class="red">*</sup></label>
		                                <input type="number" :step="getStep(price)" :min="instruments[symbol].A" :placeholder="instruments[symbol].other.closepx" v-model="price" name="Price" v-validate="{'required':true, 'greaterThen' : instruments[symbol].A}" :ref="'Market RangeInput'"/>
		                                <span class="addHighLow">
                                            <a href="javascript:void(0)" @click.stop="changeTick('Market RangeInput',1,'price')"><feather type="plus"></feather> </a>
                                            <a href="javascript:void(0)" @click.stop="changeTick('Market RangeInput',0,'price')"><feather type="minus"></feather> </a>
                                        </span>
		                            </div>
									<span class="text-danger-error" v-if="submitted && errors.has('Price')">
			                            <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">{{$t('price_required')}}</span>
			                            <span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">{{$t('price_greater_then')}} {{ instruments[symbol].A }}.</span>
			                            <span class="text-danger" v-else>{{ errors.first('Price') }}</span>
			                        </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<p class="f-12 mb-3">{{$t('volume')}}:  {{order.Quantity?(order.Quantity / 100000):'0'}} {{$t('lot')}}</p>
								<div class="form-fields mb-3 mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('quantity')}}<sup class="red">*</sup></label>
		                                <input type="number" step="0.01" :min="getMinQuantity()" placeholder="0.01" name="quantity" v-model="quantity" v-validate="{'required': true,'max_value':100,'min_value':getMinQuantity()}" autocomplete="off" ref="quantityInput"/>
		                                <span class="addHighLow">
                                            <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',1,'quantity')"><feather type="plus"></feather> </a>
                                            <a href="javascript:void(0)" @click.stop="changeTick('quantityInput',0,'quantity')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error" v-if="submitted && errors.has('quantity')">
			                            <span class="text-danger" v-if="errors.first('quantity').includes('decimal points')">{{$t('quantity_required')}}</span>
			                            <span class="text-danger" v-else>{{ errors.first('quantity') }}</span>
			                        </span>
								</div>
							</div>
						</div>
						<div class="twoColmn">
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('stop_loss')}}
	                                <input type="checkbox" v-model="edit_stop"/>
	                                <span class="checkmark"></span>
	                            </label>
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('rate')}}<sup class="red" v-if="edit_stop">*</sup></label>
		                                <input type="number" :step="getStep(stop)" :min="0" :placeholder="stopPlaceHolder" name="Stop loss" v-model="stop" v-validate="{'required':true, greaterThen : price}" v-if="edit_stop" :ref="'Stop lossInput'" @keyup="keyUp($event,'stop')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Stop loss" v-model="stop" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_stop">
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',1,'stop')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Stop lossInput',0,'stop')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Stop loss')">
		                                <span class="text-danger" v-if="errors.first('Stop loss').includes('decimal points')">{{$t('stop_loss_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Stop loss').includes('is not valid')">{{$t('stop_loss_greater_market_range')}}</span>
		                                <span class="text-danger" v-else>{{ errors.first('Stop loss') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-3 text-left">
								<label class="customCheckbox green">
	                                {{$t('trailing_stop_loss')}}:
	                                <input type="checkbox" v-model="edit_trail"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Trailing Stop Loss: -</p> -->
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('trailing_stop')}}<sup class="red" v-if="edit_trail">*</sup></label>
		                                <input type="number" step="1" min="1" placeholder="1.0" name="Trail" v-model="trail" v-validate="'required|min_value:1'" v-if="edit_trail" :ref="'Trailing StopInput'"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" name="Trail" v-model="trail" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_trail">
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',1,'trail')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Trailing StopInput',0,'trail')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('Trail')">
		                                <span class="text-danger" v-if="errors.first('Trail').includes('decimal points')">{{$t('trailing_stop_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('Trail').includes('is not valid')">{{$t('trailing_stop_greate_then_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('Trail') }}</span>
		                            </span>
								</div>
							</div>
							<div class="takePro mb-4 text-left">
								<label class="customCheckbox green">
	                                {{$t('take_profit')}}:
	                                <input type="checkbox" v-model="edit_limit"/>
	                                <span class="checkmark"></span>
	                            </label>
								<!-- <p class="f-12 mb-3">Take Profit: -</p> -->
								<div class="form-fields mx-0">
									<div class="lightBC d-flex align-items-center">
										<label>{{$t('price')}}<sup class="red" v-if="edit_limit">*</sup></label>
		                                <input type="number" :step="getStep(limit)" :min="0" :placeholder="limitPlaceHolder" name="limit" v-model="limit" v-validate="{'required':true, lessThen : price, greaterThen:0}" v-if="edit_limit" :ref="'Take ProfitInput'" @keyup="keyUp($event,'limit')"/>
		                                <input type="number" step="0.01" min="0" placeholder="0" v-model="limit" disabled v-else/>
		                                <span class="addHighLow" v-if="edit_limit">
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',1,'limit')"><feather type="plus"></feather> </a>
                                            <a href="#" @click.prevent="changeTick('Take ProfitInput',0,'limit')"><feather type="minus"></feather> </a>
                                        </span>
									</div>
									<span class="text-danger-error mt-0" v-if="submitted && errors.has('limit')">
		                                <span class="text-danger" v-if="errors.first('limit').includes('decimal points')">{{$t('target_price_required')}}</span>
		                                <span class="text-danger" v-else-if="errors.first('limit').includes('is not valid')">{{$t('target_price_market_range_greater_zero')}} 0</span>
		                                <span class="text-danger" v-else>{{ errors.first('limit') }}</span>
		                            </span>
								</div>
							</div>
						</div>
					</form>
					<!-- <ul class="openOrder-list mb-4">	
						<li class="border-bottom">Required Margin <span>102.00 USD</span></li>
					</ul> -->
					<div class="submitButton d-flex align-items-center justify-content-center mb-3">
						<button class="btn appButton greenBG mr-2 justify-content-center" @click="modifyOrder()">{{$t('ok')}}</button>
						<button class="btn appButton redBG justify-content-center" @click="$parent.orderMod = {}">{{$t('cancel')}}</button>
					</div>
				</div>
			</div>
			<div class="buySell-popup text-center openBuySell" v-else-if="tempOrderId.length > 0 && hasOrdersMsg().length == 0">
		    	<span class="closePOP" @click="$parent.orderMod = {}"><feather size="13px" type="x"></feather></span>
		    	<div class="ppSuccess-icon text-center mt-3 mb-2">
	                <feather size="28px" type="clock"></feather>
	            </div>
		    	<h3>{{$t('placed_order_pending_wait')}}</h3>
		    </div>
		    <div class="buySell-popup text-center openBuySell" v-else-if="hasOrdersMsg().length > 0">
		    	<div v-for="respId in tempOrderId">
			    	<span class="closePOP" @click="$parent.orderMod = {}"><feather size="13px" type="x"></feather></span>
			    	<div class="ppSuccess-icon text-center mt-3 mb-2" v-if="wsOrder[respId]">
		                <feather size="28px" type="check-circle" v-if="wsOrder[respId].stat == 'OK'"></feather>
		                <feather size="28px" type="alert-triangle" v-else></feather>
		            </div>
			    	<h3 :class="(wsOrder[respId].stat == 'OK')?'green':'red'" v-html="wsOrder[respId].resp_msg" v-if="wsOrder[respId]"></h3>
	            </div>
		    	<a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="$parent.orderMod = {}">{{$t('go_to_order')}}</a>
		    </div>
	    </div>
	    <div class="buySell-popup text-center openBuySell" v-else>
	    	<span class="closePOP" @click="$parent.orderMod = {}"><feather size="13px" type="x"></feather></span>
	    	<div class="ppSuccess-icon text-center mt-3 mb-2">
                <feather size="28px" type="clock"></feather>
            </div> 
	    	<!-- </h3>Please wait While order is loading...</h3> -->
	    	<app-loader/>
	    </div>
	</div>
</template>
<script>
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import { commonAllmixins } from '@/plugins/commonAll'
import { Validator } from 'vee-validate';
const paramNames = ['val'];
const lessThen = (value, [val] = {}) => { return Number(val) > value; };
Validator.extend('lessThen', lessThen, { paramNames });

const greaterThen = (value, [val] ) => { return Number(val) < Number(value); };
Validator.extend('greaterThen', greaterThen, { paramNames });
export default {
    name: 'App-pending-order',
    mixins: [commonAllmixins],
    data() {
        return {
			orderType:{
				'S' : 'Stop',
				'L' : 'Limit',
				'ES' : 'Entry Stop',
				'EL' : 'Entry Limit' 
			},
			sideClass:{
                '0':'red',
                '1':'green',
            },
            sideValue:{
                '0':'Sell',
                '1':'Buy',
            },
            lot: '',
            quantity: '',
			price: '',
			stop: '',
			stopPlaceHolder: '',
			edit_stop: false,
			trail: '',
			edit_trail: false,
			limit: '',
			limitPlaceHolder: '',
			edit_limit: false,
			comment: '',
			tempOrderId: [],
			symbol: '',
			currency_pair: '',
			placed : false,
			submitted : false,
        }
    },
    props:['order'],
    watch:{
    	quantity(val){
			let upper = 3, lower = 3;
    		try{ upper = this.instruments[this.symbol].other.Max_Trade_Size.length}catch(e){}
    		try{ lower = this.instruments[this.symbol].other.Min_Trade_Size.split('.')[1].length}catch(e){}
			this.quantity = val.toString()
				.replace(/[^\d.]/g, '')             // numbers and decimals only
              	.replace(this.getUpper(upper), '$1')   // not more than 2 digits at the beginning
              	.replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
              	.replace(this.getLower(lower), '$1');    // not more than 4 digits after decimal
    	},
    	stop(val){
    		this.changeValidation('stop',val)
    	},
    	trail(val){
			this.trail = val.toString()
				.replace(/[^\d]/g, '')             	// numbers only
              	.replace(/(^[\d]{20})[\d]/g, '$1')	// not more than 2 digits at the beginning/(^[\d]{6})[\d]/g
    	},
    	limit(val){
			this.changeValidation('limit',val)
    	},
    	edit_stop(val){
    		if(val){
				this.stop = this.order.SL.Price || ''
				this.edit_trail = false
				this.stopPlaceHolder = this.instruments[this.symbol].A
    		}else{
    			this.stop = ''
    		}
    	},
    	edit_trail(val){
    		if(val){
				this.trail = this.order.Trail.Trail || ''
				this.edit_stop = false
    		}else{
    			this.trail = ''
    		}
    	},
    	edit_limit(val){
    		if(val){
				this.limit = this.order.TP.Price || ''
				this.limitPlaceHolder = this.instruments[this.symbol].A
    		}else{
    			this.limit = ''
    		}
    	}
    },
    methods:{
    	hasOrdersMsg(){
    		let _that = this
    		return this.tempOrderId.filter(val=> _that.wsOrder.hasOwnProperty(val))
    	},
    	changeValidation(variablName,val){
    		let upper = 5, lower = 5;
    		try{ upper = this.instruments[this.symbol].B.split('.')[0].length}catch(e){}
    		try{ lower = this.instruments[this.symbol].other.Tick_Size.split('.')[1].length}catch(e){}
			this[variablName] = val.toString()
				.replace(/[^\d.]/g, '')             // numbers and decimals only
              	.replace(this.getUpper(upper), '$1')   // not more than 2 digits at the beginning
              	.replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
              	.replace(this.getLower(lower), '$1');    // not more than 4 digits after decimal
    	},
    	getUpper(val){
    		if(val == 1){ return /(^[\d]{1})[\d]/g}
    		if(val == 2){ return /(^[\d]{2})[\d]/g}
    		if(val == 3){ return /(^[\d]{3})[\d]/g}
    		if(val == 4){ return /(^[\d]{4})[\d]/g}
    		if(val == 5){ return /(^[\d]{5})[\d]/g}
    		if(val == 6){ return /(^[\d]{6})[\d]/g}
    		if(val == 7){ return /(^[\d]{7})[\d]/g}
    		if(val == 8){ return /(^[\d]{8})[\d]/g}
    		else{ return /(^[\d]{0})[\d]/g }
    	},
    	getLower(val){
    		if(val == 1){ return /(\.[\d]{1})./g}
    		if(val == 2){ return /(\.[\d]{2})./g}
    		if(val == 3){ return /(\.[\d]{3})./g}
    		if(val == 4){ return /(\.[\d]{4})./g}
    		if(val == 5){ return /(\.[\d]{5})./g}
    		if(val == 6){ return /(\.[\d]{6})./g}
    		if(val == 7){ return /(\.[\d]{7})./g}
    		if(val == 8){ return /(\.[\d]{8})./g}
    		else{ return /(^[\d]{0})[\d]/g }
    	},
    	getStep(val){
    		let data = this.instruments[this.symbol].A
    		if(val == '' || parseFloat(val) == 0){
                return (parseFloat(data)).toString()
            }else if(val && data.toString().includes('.')){
    			return 1/Math.pow(10, data.toString().split('.')[1].length)
    		}else{
    			return '1'
    		}
    	},
    	getMinQuantity(){
    		if(this.instruments[this.symbol].other.type == 'INDICIES'){
    			return 0.01
    		}else{
    			return 0.01
    		}
    	},
    	modifyOrder(){
    		let change = false
    		var _that = this
    		this.submitted =  true
    		this.tempOrderId =  []
    		_that.$validator.validate().then(valid => {
				if (valid && !_that.orderPlacedWait) {
					_that.$store.commit('SET_WS_ORDER',{})
	    			_that.submitted =  false
					if(_that.price != _that.order.Price || _that.lot != _that.quantity){
		    			const tempOrderId = new Date().getTime() + '_Price_lot'
						let orderJson = {
							"order_id" : _that.order.OrderID,
							"symbol" : _that.symbol,
							"quantity" : parseFloat(_that.quantity),
							"price" : parseFloat(_that.price),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						// console.log('update o',orderJson)
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].modifyOrder(orderJson)
						change = true
					}
					if(_that.order.SL.Price && !_that.edit_stop){
	    				_that.cancleOrder(_that.order.SL)
	    				change = true
	    			}else if(_that.stop && _that.stop != _that.order.SL.Price){
		    			const tempOrderId = new Date().getTime() + '_stop'
						let orderJson = {
							"order" : _that.order.OrderID,
							"trade" : '',
							"price" : parseFloat(_that.stop),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placestop(orderJson)
						change = true
					}
					if(_that.order.Trail.Trail && !_that.edit_trail){
						_that.cancleOrder(_that.order.Trail)
						change = true
	    			}else if(_that.trail && _that.trail != _that.order.Trail.Trail){
		    			const tempOrderId = new Date().getTime() + '_trail'
						let orderJson = {
							"order" : _that.order.OrderID,
							"trade" : '',
							"trail" : parseFloat(_that.trail),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeTrail(orderJson)
						change = true
					}
					if(_that.order.TP.Price && !_that.edit_limit){
						_that.cancleOrder(_that.order.TP)
						change = true
	    			}else if(_that.limit && _that.limit != _that.order.TP.Price){
		    			const tempOrderId = new Date().getTime() + '_limit'
						let orderJson = {
							"order" : _that.order.OrderID,
							"trade" : '',
							"price" : parseFloat(_that.limit),
							"tempOrderId" : tempOrderId,
							'localParams' : _that
						}
						_that.tempOrderId.push(orderJson.tempOrderId)
						_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeLimit(orderJson)
						change = true
					}
					if(!change){
						// console.log('please change before Modify Order')
						_that.displayError('Please Make changes before Modify Order','error')
						return
					}
					_that.placed = true
					// this.orderPending = orderJson
					// this.tempOrderId = this.orderPending.tempOrderId
				}
			});
    	},
    	cancleOrder(item){
            const tempOrderId = new Date().getTime()
            let orderJson = {
				"order_id" : item.OrderID,
				"tempOrderId" : tempOrderId,
				'localParams':this
			}
            this.tempOrderId.push(tempOrderId)
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].cancelOrder(orderJson)
        },
    	displayError(getMessage,type){
			this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 2000,
				closeOnClick: true
			});
		},
		successWs(){
			this.placed = true
        },
        failedWs(){
			this.displayError('faild to Modify order','error')
			this.placed = false
			this.$store.commit('SET_WS_ORDER',{})
        },
    },
    mounted(){
        $('.restrict-lot').on('input', function() {
            this.value = this.value
              .replace(/[^\d.]/g, '')             // numbers and decimals only
              .replace(/(^[\d]{3})[\d]/g, '$1')   // not more than 2 digits at the beginning
              .replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
              .replace(/(\.[\d]{2})./g, '$1');    // not more than 4 digits after decimal
        });
    },
    computed:{
		contractSize(){
			return (this.currencyPairs.find(val=>val.isinid.includes( this.symbol)) || {}).market_ContractSize || 100000;
		},
    	instruments(){
    	    try {
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
    },
    created(){
    	// console.log(this.order)
    	this.price = this.order.Price
    	let lotBy = 100000;
    	this.symbol = this.order.Symbol;
    	this.currency_pair = this.order.Symbol;
    	this.trail = this.order.Trail.Trail || '';
    	if(this.trail){
    		this.edit_trail = true
    	}else{
	    	this.stop = this.order.SL.Price || '';
	    	if(this.stop){
	    		this.edit_stop = true
	    	}
    	}
    	this.limit = this.order.TP.Price || '';
    	if(this.limit){
    		this.edit_limit = true
    	}
    	try{
    		lotBy = this.currencyPairs.filter(val=>val.isinid.includes( this.symbol))[0].market_ContractSize || 100000
    	}catch(e){}
		this.lot = this.order.Quantity?(this.order.Quantity / lotBy):0
		this.quantity = this.order.Quantity?(this.order.Quantity / lotBy):0
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/modify-order/pending-order-modify.vue